"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoResults = void 0;
const react_1 = require("@xstate/react");
const Events_1 = require("../../lib/constants/Events");
const Banners_1 = require("../../../components/Banners");
const messages_1 = __importDefault(require("../../lib/messages"));
const States_1 = require("../../lib/constants/States");
const react_2 = __importDefault(require("react"));
const NoResults = ({ service, isBatchedDataEmpty, isSearchResultsEmptyForDate, isLoadMoreResultEmpty, onLoadMore }) => {
    var _a, _b;
    const [currentState, send] = (0, react_1.useService)(service);
    const { jumpedToDate, availableSlots } = currentState.context;
    const noFilters = currentState.context.filterBy.timeOfDay.size +
        currentState.context.filterBy.dayOfWeek.size ===
        0;
    const isFilteredDataEmpty = !noFilters && isBatchedDataEmpty;
    const onClearFilters = () => {
        send({
            type: Events_1.CLEAR_TOOLBAR_FILTERS,
            data: {
                filterBy: {
                    dayOfWeek: new Set(),
                    timeOfDay: new Set()
                }
            }
        });
    };
    if (isSearchResultsEmptyForDate) {
        return (react_2.default.createElement(Banners_1.NoResultsBanner, { resultsMessage: messages_1.default.noJumpToDateResults, date: jumpedToDate, onClearFilters: noFilters ? undefined : onClearFilters, jumpedToDate: undefined, isLoading: currentState.matches(`${States_1.nextSearch}.${States_1.fetchAvailableSlots}`), onLoadMore: undefined }));
    }
    if (isLoadMoreResultEmpty) {
        return (react_2.default.createElement(Banners_1.NoResultsBanner, { jumpedToDate: jumpedToDate, resultsMessage: messages_1.default.noFilteredResultsNoMoreResults, date: availableSlots &&
                ((_a = availableSlots[(availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.length) - 1]) === null || _a === void 0 ? void 0 : _a.start_datetime), onClearFilters: noFilters ? undefined : onClearFilters, onLoadMore: undefined, isLoading: currentState.matches(`${States_1.nextSearch}.${States_1.fetchAvailableSlots}`) }));
    }
    if (isFilteredDataEmpty) {
        return (react_2.default.createElement(Banners_1.NoResultsBanner, { jumpedToDate: jumpedToDate, resultsMessage: messages_1.default.noFilteredResults, date: availableSlots &&
                ((_b = availableSlots[(availableSlots === null || availableSlots === void 0 ? void 0 : availableSlots.length) - 1]) === null || _b === void 0 ? void 0 : _b.start_datetime), onClearFilters: noFilters ? undefined : onClearFilters, onLoadMore: onLoadMore, isLoading: currentState.matches(`${States_1.nextSearch}.${States_1.fetchAvailableSlots}`) }));
    }
    return react_2.default.createElement(react_2.default.Fragment, null);
};
exports.NoResults = NoResults;
//# sourceMappingURL=NoResults.js.map